/**
 * The feature flag the whole correspondence-import surface hides behind (VALE-597).
 *
 * Read through `useFeatureFlags().hasFeature(...)`, which is fed by `/profile` — the same
 * backend `feature_flags` row the import endpoint gates on, so the UI and the API cannot
 * disagree about whether a firm has the feature. Off (or absent) means the thread pane is
 * not a drop target and no `Import` pill renders: the Communications tab is byte-for-byte
 * what it is today.
 *
 * Mirrors `EXTERNAL_CORRESPONDENCE_IMPORT_FLAG` in
 * `backend/src/correspondences/communications-import/`. Flag keys are the one string this
 * repo necessarily spells twice — they cross the HTTP boundary as data — which is why every
 * flag has exactly one named constant per package rather than inline literals at call sites.
 */
export const EXTERNAL_CORRESPONDENCE_IMPORT_FLAG =
  'external-correspondence-import' as const;

/**
 * The per-firm grant behind the Sent Items sweep (VALE-1216) — capturing a reply
 * a lawyer wrote in Outlook, on a thread Vale already tracks, as a record on the
 * matter.
 *
 * The frontend reads it for exactly one thing: whether to offer the undo on a
 * swept card. The sweep itself is entirely backend, so unlike the import flag
 * there is no drop target or pill riding on this.
 *
 * Mirrors `OUTLOOK_SENT_ITEMS_SYNC_FLAG` in
 * `backend/src/customer-integrations/email/constants/`.
 */
export const OUTLOOK_SENT_ITEMS_SYNC_FLAG = 'outlook-sent-items-sync' as const;
